import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
import Img1 from  '../../images/NewFaq/1.png'
import Img2 from  '../../images/NewFaq/2.png'
import Img3 from  '../../images/NewFaq/3.png'
import Img4 from  '../../images/NewFaq/4.png'
import Img5 from  '../../images/NewFaq/5.png'
import Img6 from  '../../images/NewFaq/6.png'
import Img7 from  '../../images/NewFaq/7.png'
import Img8 from  '../../images/NewFaq/8.png'
import Img9 from  '../../images/NewFaq/9.png'
import Img10 from  '../../images/NewFaq/10.png'
import Img11 from  '../../images/NewFaq/11.png'
import Img12 from  '../../images/NewFaq/12.png'
export default function Faq() {
    const Data=[
        {url:Img1,
         title:"General Quries",
         path:'/faqs/general-queries'
        },
        {url:Img2,
         title:"Reward Points",
         path:'/faqs/rewards-points'
        },
        {url:Img3,
         title:"Leaderboards & Progression",
         path:'/faqs/leaderboard-and-progression'
        },
        {url:Img4,
         title:"Gameplay Queries",
         path:'/faqs/gameplay-queries'
        },
        {url:Img5,
         title:"Baazi Store",
         path:'/faqs/baazi-store'
        },
        {url:Img6,
         title:"Baazi Select Membership",
         path:'/faqs/baazi-select-membership'
        },
        {url:Img7,
         title:"Task Rewards",
         path:'/faqs/task-rewards'
        },
        {url:Img8,
         title:"Technical Queries",
         path:'/faqs/technical-queries'
        },
        {url:Img9,
         title:"Wallet",
         path:'/faqs/wallet'
        },
        {url:Img10,
         title:"Legal",
         path:'/faqs/legality'
        },
        {url:Img11,
         title:"Terms & Conditions",
         path:'/faqs/tnc'
        },
        {url:Img12,
         title:"Privacy Policy",
         path:'/faqs/privacy-policy'
        }

    ]
  return (
    <div >
        <Topheader colorbox="newfaq_header_color" title="FAQs" />
        <div className="main-container mb-5">

        {Data.slice(0,9).map((item,index)=>{
            return(
            <a href={item.path} key={index} className={style.nav_box}>
                <div className={style.sub}>
                <img src={item.url} width="24px" height="24px" alt=''/>
                <div className={style.title}>{item.title}</div>
                </div>
                 <svg className={style.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.0002 7L8.00051 11L4.00025 7" stroke="#041B67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </a>
            )
        })}

        <div className={style.brd}></div>
         {Data.slice(9,12).map((item,index)=>{
            return(
            <a href={item.path} key={index} className={style.nav_box}>
                <div className={style.sub}>
                <img src={item.url} width="24px" height="24px" alt=''/>
                <div className={style.title}>{item.title}</div>
                </div>
                 <svg className={style.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.0002 7L8.00051 11L4.00025 7" stroke="#041B67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </a>
            )
        })}

                <div className={style.brd}></div>
                <div className='px-4 mt-1'>
                <div className={style.text1}>Need more help?</div>
                <div className={style.text2}>Reach out to our Support Team through the app menu, we’ll get back to you quickly.</div>
                </div>
        </div>
    </div>
  )
}
